import { ResearchId } from "../../../state/AppState.ts";
import { HttpClient, Result } from "../../../../http/HttpClient.ts";

export class SummaryApiService {
  constructor(private readonly httpClient: HttpClient) {}

  regenerateSummary(param: { researchId: ResearchId }): Result {
    return this.httpClient.post(
      `/research/${param.researchId}/summarization/regenerate`,
      null,
    );
  }
}
